import { render, staticRenderFns } from "./BreadcrumbsHelper.vue?vue&type=template&id=8d3a3e5e&scoped=true"
import script from "./BreadcrumbsHelper.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsHelper.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbsHelper.vue?vue&type=style&index=0&id=8d3a3e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3a3e5e",
  null
  
)

export default component.exports